import React, { useState } from 'react'
import { useAppVersion } from '../hooks/app-version'
import { IconUpdateAvailable } from '../icon/icon'

// "A new version is available." Offers a reload; never performs one.
//
// Deliberately not automatic. This panel is full of react-hook-form forms and
// AG Grid state, and reloading underneath someone mid-edit destroys work and
// reads as a crash. The tab keeps running the older build for as long as they
// want it to.
//
// Bottom-left so it cannot collide with the get-the-app banner, which takes the
// top, and so it stays clear of the header actions.
//
// Colours come from theme variables (scss/other.scss, .edxr-notice):
// the card is white in light mode and the surface colour in dark mode, with
// body/muted text that follows the theme.
export const UpdateBanner = () => {
  const { updateAvailable, reload } = useAppVersion()
  const [dismissed, setDismissed] = useState(false)

  if (!updateAvailable || dismissed) return null

  return (
    <div
      className="edxr-notice position-fixed bottom-0 start-0 m-3 p-3 border rounded-3 shadow d-flex align-items-center gap-3"
      style={{ zIndex: 1080, maxWidth: 420 }}
      role="status"
    >
      {/* Square tile the height of the two text lines — the same object the
          device cell uses on the sign-in confirm screen, so the two notices in
          this panel read as the same family. A bare coloured dot said nothing;
          the rotate glyph names the action the buttons offer. */}
      <span
        className="edxr-notice-tile rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
        style={{ width: 40, height: 40 }}
        aria-hidden="true"
      >
        <IconUpdateAvailable />
      </span>

      <div className="small">
        <div className="fw-semibold">A new version is available</div>
        <div className="text-muted">Reload to pick up the latest changes.</div>
      </div>
      <div className="d-flex gap-2 ms-auto">
        {/* Dismiss hides the banner for this tab only. The next reload gets the
            new build regardless, so there is nothing to remember. */}
        <button type="button" className="btn btn-sm btn-outline-secondary edxr-notice-later" onClick={() => setDismissed(true)}>
          Later
        </button>
        <button type="button" className="btn btn-sm btn-primary" onClick={reload}>
          Reload
        </button>
      </div>
    </div>
  )
}
